import {
  pollPartnerSubscriptionCheckout,
  pollHighlightCheckout,
  pollPartnerCheckout,
  pollInvoiceCheckout,
} from '@/api/partner';

export const STRIPE_EMBEDDED_CONTEXT_KEY = 'stripe:embeddedCheckoutContext';

export const STRIPE_POLL_KIND = {
  PARTNER_SUBSCRIPTION: 'partner_subscription',
  PARTNER_HIGHLIGHT: 'partner_highlight',
  PARTNER_INVOICE: 'partner_invoice',
  PARTNER_GENERIC: 'partner_generic',
};

export const stashStripeEmbeddedCheckoutContext = (context = {}) => {
  sessionStorage.setItem(STRIPE_EMBEDDED_CONTEXT_KEY, JSON.stringify({
    pollKind: context.pollKind || STRIPE_POLL_KIND.PARTNER_GENERIC,
    returnRoute: context.returnRoute || { name: 'navigation.cockpit' },
    sessionId: context.sessionId || '',
    invoiceId: context.invoiceId || '',
  }));
};

export const readStripeEmbeddedCheckoutContext = () => {
  try {
    const raw = sessionStorage.getItem(STRIPE_EMBEDDED_CONTEXT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const clearStripeEmbeddedCheckoutContext = () => {
  sessionStorage.removeItem(STRIPE_EMBEDDED_CONTEXT_KEY);
};

export const pollStripeEmbeddedCheckout = async (pollKind, sessionId) => {
  if (!sessionId) return { ok: false };

  switch (pollKind) {
    case STRIPE_POLL_KIND.PARTNER_SUBSCRIPTION: {
      const subResult = await pollPartnerSubscriptionCheckout(sessionId);
      return {
        ok: Boolean(subResult?.ready && subResult?.status?.subscription?.isActive),
        data: subResult,
        variant: 'success',
      };
    }
    case STRIPE_POLL_KIND.PARTNER_HIGHLIGHT: {
      const highlightResult = await pollHighlightCheckout(sessionId);
      return {
        ok: Boolean(highlightResult?.ready && highlightResult?.purchase),
        data: highlightResult,
        variant: 'highlight_success',
      };
    }
    case STRIPE_POLL_KIND.PARTNER_INVOICE: {
      const invoiceResult = await pollInvoiceCheckout(sessionId);
      return {
        ok: Boolean(invoiceResult?.ready),
        data: invoiceResult,
        variant: 'success',
      };
    }
    default: {
      const genericResult = await pollPartnerCheckout(sessionId);
      if (!genericResult?.ready) return { ok: false, data: genericResult };
      if (genericResult.purchaseType === 'highlight') {
        return { ok: true, data: genericResult, variant: 'highlight_success' };
      }
      return { ok: true, data: genericResult, variant: 'success' };
    }
  }
};
